import {useEffect, useState} from "react";
import {deleteWeeklyItem, editWeeklyItem} from "../../Services/WeeklyMenuService";
import {WeeklyDish} from "../../Types/WeeklyDish";

type Props = {
  dish: WeeklyDish;
  onSaved: () => void;
};

function EditWeeklyItemBody({dish, onSaved}: Props) {
  const [amount, setAmount] = useState(String(dish.dishAmount));

  useEffect(() => {
    setAmount(String(dish.dishAmount));
  }, [dish]);

  const handleSave = async () => {
    const parsedAmount = Number(amount);

    if (!Number.isInteger(parsedAmount) || parsedAmount < 1) {
      alert("Vul een geldig aantal in");
      return;
    }

    try {
      await editWeeklyItem({
        weekId: dish.weekId,
        dishAmount: parsedAmount,
      });

      onSaved();
    } catch (err) {
      console.error(err);
      alert("Opslaan mislukt");
    }
  };

  const handleDelete = async () => {
    try {
      await deleteWeeklyItem(dish.weekId!)
    } catch (err) {
      console.error(err);
      alert("Verwijderen mislukt");
    }

    onSaved();
  };

  return (
    <div className="popup-form">
      <h2 className="header-1">
        {dish.menuItem.name}
      </h2>

      <p className="popup-description">
        Verander hier het aantal van dit gerecht op het weekmenu.
        De standaard gegevens van het gerecht worden niet aangepast.
      </p>

      <div className="form-item">
        <h3 className="input-label">
          Aantal
        </h3>

        <input
          id="weekly-amount"
          type="number"
          min="1"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          className="input-field input-field--small"
        />
      </div>

      <div className="double-buttons">
        <button type="button" onClick={handleDelete} className="button">
          Verwijderen
        </button>
        <button type="button" onClick={handleSave} className="button">
          Opslaan
        </button>
      </div>
    </div>
  );
}

export default EditWeeklyItemBody;